import React, { useCallback } from 'react';

import { CheckmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseMenuItem, Stack, Typography, usePopoverContext } from '@lyearn/ui';
import { ListItemProps, MenuItemProps } from '@/components/SortMenu/types';

function MenuItemsDesktop<T extends ListItemProps>(props: MenuItemProps<T>) {
  const { actions, onMenuClick, showBottomSheet, overrides } = props;
  const { onClose } = usePopoverContext();

  const onItemClick = useCallback(
    (id: string, item: T) => {
      onMenuClick(id, item);
      onClose();
    },
    [onMenuClick, onClose],
  );

  return (
    <>
      {actions.map((item: T) => (
        <BaseMenuItem
          key={item.id}
          className={cn(
            'flex h-40 items-center justify-between rounded-8 p-10 hover:bg-interactive-white-hover xs:mx-8 xs:px-12',
            { 'bg-bg-secondary': item.isSelected },
          )}
          data-action={item.id}
          onClick={() => onItemClick(item.id, item)}>
          <Stack alignItems="center" justifyContent="between">
            {item.icon ? (
              <Stack
                alignItems="center"
                className={cn(
                  'me-12',
                  item.isSelected ? 'text-text-primary' : 'text-icon-secondary',
                )}
                justifyContent="center">
                {item.icon}
              </Stack>
            ) : null}
            <Typography
              className="me-20"
              color={
                overrides?.Typography?.color || item.isSelected
                  ? 'text-text-primary'
                  : 'text-text-secondary'
              }
              variant={
                overrides?.Typography?.variant || showBottomSheet
                  ? 'body-short-01'
                  : 'body-short-02'
              }>
              {item.label}
            </Typography>
          </Stack>
          {item.isSelected ? <CheckmarkOutline className="h-16 w-16 flex-shrink-0" /> : null}
        </BaseMenuItem>
      ))}
    </>
  );
}

export default MenuItemsDesktop;
